export default "__VITE_ASSET__D3ii_m3d__";